module.exports = __webpack_public_path__ + "static/media/labDiagnosis_bg.49f1cc21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/labDiagnosis_bg.jpg
// module id = 2244
// module chunks = 0